import { Injectable } from '@angular/core';
import { RestClientService } from '../../rest/rest-client.service';
import { Control } from '../model/control';

@Injectable({
    providedIn: 'root'
  })
  export class ControlService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getDynamicControlsByRequestId(requestId) {
      return this._restClientService.load<Control[]>('control/dynamic-controls-by-requestid?requestId='+requestId);
    }
    
    getControls() {
      return this._restClientService.load<Control[]>('control/controls');
    }
    
    getControlById(controlId) {
      return this._restClientService.load<Control>('control/controls-by-id/'+controlId);
    }
    
    putControl(control: Control) {
      return this._restClientService.put<void>('control/update-control', control);
    }
 
    postControl(control: Control) {
      return this._restClientService.save<void>('control/add-control', control);
    }
 
    deleteControl(controlId){
      return  this._restClientService.delete<void>('control/delete-control/'+controlId);
    }
    

}      

    